import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
/**
 * A message laid over a chart with nothing to show; covers its nearest positioned ancestor.
 * `ctaHref` links outside in a new tab, `ctaRouterLink` inside the app; `scrim` fades the chart behind.
 */
@Component({
  selector: 'app-chart-overlay',
  templateUrl: './chart-overlay.component.html',
  styleUrl: './chart-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChartOverlayComponent {
  @Input({ required: true }) public message: string;
  @Input() public ctaLabel?: string;
  @Input() public ctaHref?: string;
  @Input() public ctaRouterLink?: string | string[];
  @Input() public icon = 'info_outline';
  @Input() public scrim = false;

  @HostBinding('class.chart-overlay--large')
  @Input()
  public large = false;
  @HostBinding('class.chart-overlay--inherit-font')
  @Input()
  public inheritFont = false;
}
